module.exports = __webpack_public_path__ + "img/9791156758518.3122bf55.jpg";